var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongDianzanXianxing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.176 7.075l2.98-4.424a.6.6 0 01.497-.265h.768a.6.6 0 01.6.637L9.824 6.16h3.028a.6.6 0 01.586.728l-1.238 5.64a.5.5 0 01-.488.393h-8.81a.5.5 0 01-.5-.5V7.575a.5.5 0 01.5-.5h2.273z",
    stroke: "#3F465C",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F465C",
    d: "M5.063 7v6"
  })));
}
export default __webpack_public_path__ + "static/tongyong_dianzan_xianxing.94e49af9.svg";
export { SvgTongyongDianzanXianxing as ReactComponent };